import React, { useState } from 'react';
import blurTop from '../../assets/splashScreen/Blur.svg'
import kyc from '../../assets/splashScreen/Group 714.svg'
import { useNavigate } from 'react-router-dom';

// Inline SVG for the ID Scan illustration (reused from previous version)

// Inline SVG for the ID Card Icon (used in the list)
const IdCardIcon = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect width="20" height="15" x="2" y="5" rx="2" />
        <line x1="2" x2="22" y1="10" y2="10" />
        <line x1="6" x2="6" y1="14" y2="16" />
        <line x1="9" x2="18" y1="14" y2="14" />
        <circle cx="6" cy="7.5" r="1.5" />
    </svg>
);

// Inline SVG for the Camera Icon (used in the list)
const CameraIcon = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3L14.5 4z" />
        <circle cx="12" cy="13" r="3" />
    </svg>
);

/**
 * KYCVerificationForm Component
 * Renders the Document Upload screen based on the latest image.
 */
export default function KYCVerificationIdForm({ onKycSubmit, onBack }) {

    const navigate = useNavigate()
    const handleAction = (action) => {
        console.log(`Action clicked: ${action}. Navigating to camera/upload screen.`);
        // For flow completeness, we simulate completion/navigation

        if(action === 'ID_PHOTO'){
            navigate('/kycdocselect')
        }
        if(action === 'SELFIE'){
            navigate('/selfie')
        }
        if(onKycSubmit) onKycSubmit(); 
    };

    return (
        <div className="min-h-screen bg-white text-gray-800 px-6 py-10 flex flex-col relative overflow-hidden">
        
        {/* Decorative Blur Background */}
        <img
            src={blurTop}
            alt="Decorative background blur"
            className="absolute top-0 left-0 w-full h-auto pointer-events-none select-none opacity-50 max-h-48 object-cover"
        />

        {/* Content Area */}
        <div className="relative z-10 w-full max-w-sm mx-auto">
            
            {/* Back Button (Positioned absolutely near the top-left) */}
            <button 
                className="absolute top-[-2rem] left-0 p-2 text-gray-800 hover:text-blue-600 transition-colors"
                // onClick={onBack}
                onClick={()=>{
                    navigate('/kycaddress')
                }}
                aria-label="Go back"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
            </button>

            {/* Illustration (Centering it manually based on context) */}
                 <div className="flex-1 flex justify-center items-center mt-4">
          <img
            src={kyc}
            alt=""
            className="w-full max-w-xs max-h-[45vh] object-contain"
          />
        </div>

            {/* Header Text */}
            <h1 className="text-3xl font-bold text-gray-900 mt-2">ID</h1>
            
            <p className="text-gray-600 text-sm mt-1 mb-8">
                Please submit the following documents verify your profile.
            </p>

            {/* Documents Upload Card */}
            <div className="bg-white p-6 rounded-2xl shadow-xl border border-gray-100">
                <h2 className="text-lg font-semibold text-gray-900 mb-3">Documents upload</h2>
                <p className="text-gray-500 text-sm mb-6">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et.
                </p>

                {/* List Item 1: Valid ID Photo */}
                <button 
                    onClick={() => handleAction('ID_PHOTO')}
                    className="w-full flex items-center justify-between py-4 border-b border-gray-100 hover:bg-gray-50 transition duration-150 -mx-2 px-2 rounded-lg"
                >
                    <div className="flex items-start space-x-4">
                        <IdCardIcon className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" />
                        <div className="text-left">
                            <p className="font-medium text-gray-800">Take a picture of your vaild ID</p>
                            <p className="text-xs text-gray-500 mt-0.5">To check your personal informations are correct</p>
                        </div>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-400">
                        <polyline points="9 18 15 12 9 6"></polyline>
                    </svg>
                </button>

                {/* List Item 2: Selfie */}
                <button 
                    onClick={() => handleAction('SELFIE')}
                    className="w-full flex items-center justify-between py-4 hover:bg-gray-50 transition duration-150 -mx-2 px-2 rounded-lg"
                >
                    <div className="flex items-start space-x-4">
                        <CameraIcon className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" />
                        <div className="text-left">
                            <p className="font-medium text-gray-800">Take a selfie of yourself</p>
                            <p className="text-xs text-gray-500 mt-0.5">To match your face to your ID photo</p>
                        </div>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-400">
                        <polyline points="9 18 15 12 9 6"></polyline>
                    </svg>
                </button>
            </div>
            
        </div>
        </div>
    );
}